import { Link } from "react-router-dom";
import { type Cents, cents, formatMoney } from "@/domain/money";
import { salarySplit } from "@/domain/salary_split";

export function SalarySplit({ saved, ceiling, currency }: { saved: Cents; ceiling: Cents; currency: string }): React.JSX.Element {
  const split = salarySplit(saved, ceiling);
  return <div className="w-full max-w-phi-12 text-phi-n1">
    <div aria-hidden="true" className="flex gap-px h-phi-n2 overflow-hidden rounded-phi-n6">
      <span className="min-w-0 basis-0" style={{ flexGrow: split.savedPercent, backgroundImage: "repeating-linear-gradient(135deg, var(--color-acc) 0, var(--color-acc) 2px, transparent 2px, transparent 4px)" }} />
      <span className="min-w-0 basis-0 bg-acc opacity-30" style={{ flexGrow: split.spendPercent }} />
    </div>
    <div className="flex flex-wrap items-center justify-between gap-x-phi-n1">
      <Link to="/savings" className="min-h-[44px] content-center text-acc">Saved <span className="fig">{formatMoney(saved, currency)}</span> ›</Link>
      <span>To spend <span className="fig">{formatMoney(ceiling, currency)}</span></span>
    </div>
    <p className="text-tx-2">of a <span className="fig">{formatMoney(cents(saved + ceiling), currency)}</span> salary</p>
  </div>;
}
